import { render, staticRenderFns } from "./AboutGame.vue?vue&type=template&id=ac341422&scoped=true"
import script from "./AboutGame.vue?vue&type=script&lang=js"
export * from "./AboutGame.vue?vue&type=script&lang=js"
import style0 from "./AboutGame.vue?vue&type=style&index=0&id=ac341422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac341422",
  null
  
)

export default component.exports